export function breakoutSessions() {
    const form = $("form.form-register-guests");
    form.on("click", "header", function (e) {
        let parent = $(this).parent();
        if (parent.hasClass("opened")) {
            parent.removeClass("opened").find(".hidden-info").slideUp();
        } else {
            // form.find(".form-section").removeClass("opened").find(".hidden-info").slideUp();
            parent.addClass("opened").find(".hidden-info").slideDown();
        }

        e.preventDefault();
    });

    let $radios = $('input[type=radio]');
    let $total_sessions_booked = $('.total-sessions-booked');
    $radios.click(function () {

        let previousValue = $(this).attr('previousValue');
        let name = $(this).attr('name');
        let thisTime = $(this).attr('data-time');

        $('input[data-time="' + thisTime + '"]').parent().removeClass('isDisabledDuplicate');

        if (previousValue === 'checked') {
            $(this).prop('checked', false);
            $(this).attr('previousValue', false);
        }
        else {
            $("input[name=" + name + "]:radio").attr('previousValue', false);
            $(this).attr('previousValue', 'checked');

            //disable duplicate times
            $(this).closest('.form-section').siblings().find("input[data-time='" + thisTime + "']").parent().addClass('isDisabledDuplicate');

            let radioItems = $(this).parent().siblings(".item-radio:not(.isDisabledDuplicate)");
            if (radioItems.length) {
                radioItems.each(function () {
                    let time = $(this).find('input').attr('data-time');
                    $('input[data-time="' + time + '"]').parent().removeClass('isDisabledDuplicate');
                });
            }
        }

        let $total_booked = $radios.filter(":checked").length;
        $total_sessions_booked.find('span').text($total_booked);

        if ($total_booked === 4) {
            $radios.not(':checked').parent().addClass('isDisabledLimit');
        } else {
            $radios.parent().removeClass('isDisabledLimit');
        }
    });

    form.find('#i_am').on('change', function () {
        let element = $("option:selected", this);
        let val = element.val();

        if (val === 'distributor-sales-consultant' || val === 'mo-employee' || val === '')
            form.find('.stylist-license').hide().find('.input-text').addClass('hidden');
        else
            form.find('.stylist-license').show().find('.input-text').removeClass('hidden');
    });
    form.find('#i_am').trigger('change');

    form.find('input[type=checkbox]').on('change', function () {
        let $check_privacy = form.find("input[type='checkbox']");

        if ($check_privacy.length === $check_privacy.filter(":checked").length) {
            form.find('.button').removeClass('isDisabled');
        } else {
            form.find('.button').addClass('isDisabled');
        }
    });

    const pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    let form_validated = true;

    function field_validadte($field) {
        let $parent = $field.closest('.form-row'),
            validate_required = $parent.is('.validate-required'),
            validate_email = $parent.is('.validate-email'),
            validate_phone = $parent.is('.validate-phone'),
            validated = true;

        if (validate_required) {
            if ($field.val() === '') {
                $parent.addClass('woocommerce-invalid');
                validated = form_validated = false;
            }
            else {
                if (validate_email) {
                    if (!pattern.test($field.val())) {
                        $parent.addClass('woocommerce-invalid');
                        validated = form_validated = false;
                    }
                }

                if (validate_phone) {
                    let filter = /^[0-9-+]+$/;
                    if (!filter.test($field.val())) {
                        $parent.addClass('woocommerce-invalid');
                        validated = form_validated = false;
                    }
                }
            }
        }

        if (validated) {
            $parent.removeClass('woocommerce-invalid');
        }
    }

    form.on('input', '.input-text:not(.hidden)', function () {
        let $this = $(this);

        field_validadte($this);
    });

    form.submit(function (e) {
        e.preventDefault();

        let $this = $(this),
            $response = $this.find('.response-error'),
            $submit = $this.find('.button');

        form_validated = true;

        $this.find('.input-text:not(.hidden)').each(function () {
            let $this = $(this);

            field_validadte($this);
        });

        if (form_validated) {
            let arr_data = $('input[name!=check_privacy]', this).serializeArray();
            arr_data.push({name: "personal_details", value: $('#i_am').find(":selected").val()});
            arr_data.push({name: "practice_region", value: $('#practice_region').find(":selected").val()});

            let data = {
                'action': 'book_guest',
                'data': arr_data
            };

            $.ajax({
                url: ajax_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                    $submit.addClass('isDisabled').attr("disabled", true);
                    $response.text('');
                },
                success: function (res) {
                    if (res.status === true) {
                        $('.holder-form').hide();
                        $('.response-success').show();
                    } else {
                        $response.text(res.message);
                        $submit.removeClass('isDisabled').attr("disabled", false);
                    }
                }
            });

        } else {
            $response.text('One or more fields have an error. Please check and try again.');
        }

        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/breakout-sessions.js